import '/@/design/index.less';
// 注册 windi
import 'virtual:windi-base.css';
import 'virtual:windi-components.css';
import 'virtual:windi-utilities.css';
import 'virtual:windi-devtools';

// bpmn 工作流绘图工具的样式
// import "/@/views/flowable/assets/diagram-js.css"  // 左边工具栏以及编辑节点的样式
// import "/@/views/flowable/assets/bpmn-font/css/bpmn.css"
// import "/@/views/flowable/assets/bpmn-font/css/bpmn-codes.css"
// import "/@/views/flowable/assets/bpmn-font/css/bpmn-embedded.css"

// 注册图标
import 'virtual:svg-icons-register';
import App from './App.vue';
import {createApp} from 'vue';
import {initAppConfigStore} from '/@/logics/initAppConfig';
import {setupErrorHandle} from '/@/logics/error-handle';
import {router, setupRouter} from '/@/router';
import {setupRouterGuard} from '/@/router/guard';
import {setupStore} from '/@/store';
import {setupGlobDirectives} from '/@/directives';
import {setupI18n} from '/@/locales/setupI18n';
import {registerGlobComp} from '/@/components/registerGlobComp';
// import {registerThirdComp} from '/@/settings/registerThirdComp';
import {useSso} from '/@/hooks/web/useSso';
//注册公共css
import '/@/assets/css/common.css';
import '/@/assets/less/common.less';
import '/@/assets/css/customFonts.css';

import * as VComponents from '/@/components/FormDesignBasic/index'
// @ts-ignore
import Tabs from '/@/components/FormDesignBasic/tabs';
// @ts-ignore
import VCol from '/@/components/FormDesignBasic/col';
//注册公共css
import '/@/views/service/form/designForm/components/assets/scss/element-var.scss'
import '/@/views/service/form/designForm/components/assets/scss/layout.scss'
import '/@/views/service/form/designForm/components/assets/scss/form.scss'
import '/@/views/service/form/designForm/components/assets/scss/v-form.css'
import '/@/views/service/form/designForm/components/assets/scss/v-col.css'
// @ts-ignore
import { Bus } from '/@/views/service/form/designForm/components/utils/types'
// @ts-ignore
import EventEmitter from '/@/views/service/form/designForm/components/utils/event-emitter'
import initSensors from '/@/logics/buryPoint';
import { complianceRule } from '/@/compliance/directive';
// 配置高德地图安全密钥
window._AMapSecurityConfig = {
	securityJsCode: '8ea17351a372b4fe8a191338aeb18bf0' //*  安全密钥
}

// 在本地开发中引入的,以提高浏览器响应速度
if (import.meta.env.DEV) {
    import('ant-design-vue/dist/antd.less');
}
async function bootstrap() {
    // 创建应用实例
    const app = createApp(App);
    // 初始化埋点配置
    initSensors();

    
    // 多语言配置,异步情况:语言文件可以从服务器端获得
    await setupI18n(app);

    // 配置存储
    setupStore(app);

    // 初始化内部系统配置
    initAppConfigStore();

    // 注册全局组件
    registerGlobComp(app);

    //CAS单点登录
    await useSso().ssoLogin();

    // 配置路由
    setupRouter(app);

    // 路由保护
    setupRouterGuard(router);

    // 注册全局指令
    setupGlobDirectives(app);

    // 配置全局错误处理
    setupErrorHandle(app);

    // 注册第三方组件
    // await registerThirdComp(app);

    // 当路由准备好时在执行挂载( https://next.router.vuejs.org/api/#isready)
    await router.isReady();

    app.config.globalProperties.$bus = {
        ee: new EventEmitter()
    } as Bus;

    for (const [key, component] of Object.entries(VComponents)) {
        app.component(key, component)
    }
    
    // 注册合规管控指令
    app.directive('compliancerule', complianceRule);
    // 挂载应用
    app.use(Tabs).use(VCol).mount('#app', true);
}

bootstrap();
